import { render, staticRenderFns } from "./ContributionDashboard.vue?vue&type=template&id=a158659c&scoped=true"
import script from "./ContributionDashboard.vue?vue&type=script&lang=ts"
export * from "./ContributionDashboard.vue?vue&type=script&lang=ts"
import style0 from "./ContributionDashboard.vue?vue&type=style&index=0&id=a158659c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a158659c",
  null
  
)

export default component.exports